import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { useProjection } from '../hooks/useProjection';
import { ProjectTileCard } from '../components/ProjectTileCard';
import { EmptyState, ErrorState, SkeletonTiles } from '../components/States';
import { useState } from 'react';

export function Projects() {
  const projection = useProjection(() => api.portfolio(), []);
  const [query, setQuery] = useState('');

  if (projection.loading) return <SkeletonTiles />;
  if (projection.error) return <ErrorState error={projection.error} onRetry={projection.reload} />;
  const view = projection.data!;
  const filtered = view.projects.filter(
    (tile) =>
      tile.name.toLowerCase().includes(query.toLowerCase()) ||
      tile.slug.includes(query.toLowerCase()),
  );

  return (
    <>
      <header className="topstrip">
        <div>
          <div className="label">{view.tenant.name}</div>
          <h1 className="topstrip__title">Projects</h1>
        </div>
        <div className="topstrip__meta">
          <label className="inline inline--tight small">
            <span className="sr-only">Search projects</span>
            <input
              className="btn btn--sm"
              style={{ justifyContent: 'flex-start', minWidth: 180 }}
              type="search"
              placeholder="Search projects"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
            />
          </label>
          <Link className="btn btn--sm btn--primary" to="/integrations/connect">
            Connect existing project
          </Link>
        </div>
      </header>

      {filtered.length === 0 ? (
        <EmptyState
          title={query ? 'No project matches that search' : 'No projects yet'}
          body={
            query
              ? 'Try a different name or slug.'
              : 'Connect an existing repository, or bootstrap a new project, to start observing it.'
          }
        />
      ) : (
        <div className="grid grid--tiles">
          {filtered.map((tile) => (
            <ProjectTileCard key={tile.id} tile={tile} />
          ))}
        </div>
      )}
    </>
  );
}
